var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33398 2.32618C1.33398 1.67874 1.33398 1.35502 1.46898 1.17657C1.58658 1.02111 1.76633 0.924908 1.96092 0.91329C2.18427 0.899953 2.45363 1.07952 2.99233 1.43866L10.0027 6.11224C10.4478 6.40899 10.6704 6.55736 10.7479 6.74438C10.8158 6.90788 10.8158 7.09164 10.7479 7.25514C10.6704 7.44216 10.4478 7.59053 10.0027 7.88728L2.99233 12.5609C2.45363 12.92 2.18427 13.0996 1.96092 13.0862C1.76633 13.0746 1.58658 12.9784 1.46898 12.823C1.33398 12.6445 1.33398 12.3208 1.33398 11.6733V2.32618Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/playIcon.4b2894b6e74139cf95b73ed1a0b1fd9a.svg";
export { ForwardRef as ReactComponent };